import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getFeedbackFiles = (state: IRootState) => state.feedback.files;
export const getFeedbackError = (state: IRootState) => state.feedback.error;
export const getFeedbackForm = (state: IRootState) => state.feedback.form;
export const getFeedbackKnmData = (state: IRootState) => state.feedback.knmData;
export const getFeedbackPlanData = (state: IRootState) => state.feedback.planData;
